/** ¿La ficha es de arrendamiento (largo plazo o vacacional)? */
export function esOperacionAlquiler(op) {
  const s = String(op || "").trim().toLowerCase();
  return s === "alquiler" || s === "alquiler vacacional";
}
